import { Molecule } from "AppReact";
import styled from "styled-components";
import { DeleteButton } from './../atoms';
import { TrashBinSvg } from 'components/icons';

const template = styled.div``;

export default Molecule({
    template,
    atoms: [
        {
            component: DeleteButton,
            name: 'Delete',
            displayValue: ({ }) => TrashBinSvg({ width: '14', height: '16.5' }),
        },
    ],
})
